import React, { useState, useEffect } from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import { useAuth } from '../../Components/Contexts/AuthContext';
import Hi from '../../assets/Images/wave.png';
import AddItem from '../../Components/Supervisor/AddItem';
import AddMeal from '../../Components/Supervisor/AddMeal';
import AddFoodType from '../../Components/Supervisor/AddFoodType';
import AddSource from '../../Components/Supervisor/AddSource';
import AddReason from '../../Components/Supervisor/AddReason';
import Home from '../../Components/Supervisor/Home';
import Table from '../../Components/Supervisor/Table';
import TableTemporary from '../../Components/Supervisor/TableTemporary';

function SupervisorDashboard() {
  const [activeLink, setActiveLink] = useState('Home');
  const [items, setItems] = useState([]);
  const { token } = useAuth(); 


  const addItem = (newItem) => {
    setItems([...items, newItem]); // Add the new item to the list
  };

  useEffect(() => {
    // console.log('Token:', token); // Debug: Ensure token is available
    // Use token for API calls if necessary
  }, [token]);

  return (
    <div className="flex w-full">
      {/* Sidebar */}
      <Sidebar
        activeLink={activeLink}
        setActiveLink={setActiveLink}
        isSupervisorDashboard={true} // Pass a flag to indicate this is SupervisorDashboard
      />

      {/* Welcome Message */}
      <div className="fixed top-6 md:top-6 right-[5rem] md:right-[7rem] lg:right-[20rem] flex items-center space-x-2 rtl:space-x-reverse">
        <img src={Hi} alt="Wave Icon" className="w-6 h-6" />
        <span className="text-lg font-bold text-gray-700">مرحباً بك</span>
      </div>

      {/* Main Content */}
      <div className="flex-grow max-w-full mb-0 md:mb-60 lg:mb-0 lg:max-w-[calc(100%-16rem)] p-6">
        {activeLink === 'Home' && <Home />}
        {activeLink === 'Add-item' && <AddItem addItem={addItem} />}
        {activeLink === 'Add-meal' && <AddMeal AddMeal={AddMeal} />}
        {activeLink === 'Add-food-type' && <AddFoodType AddFoodType={AddFoodType} />}
        {activeLink === 'Add-source' && <AddSource AddSource={AddSource} />}
        {activeLink === 'Add-reason' && <AddReason AddReason={AddReason} />}
        {activeLink === 'Table' && <Table items={items} />}
        {activeLink === 'TableTemporary' && <TableTemporary items={items} />}
      </div>
    </div>
  );
}

export default SupervisorDashboard;
